import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.064 5.108A8 8 0 1 0 19.748 14H21.8c-.927 4.564-4.962 8-9.8 8-5.523 0-10-4.477-10-10S6.477 2 12 2c2.038 0 3.934.61 5.515 1.657z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M14.586 6.586A6 6 0 1 0 12 18a1 1 0 1 0 0-2 4 4 0 1 1 1.035-7.864z"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M19.071 4.929A10 10 0 0 1 22 12h-8a2 2 0 1 1-.586-1.414z" })
);
var SvgLivefeedOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LivefeedOutlined_default = SvgLivefeedOutlined;

export { LivefeedOutlined_default as default };
